export { default as resources_ja } from '../resources/resources_ja';

import { registerAdminSettingsExtension } from './resolvers/adminSettingsResolver';

export const initPlugin = () => {
  registerAdminSettingsExtension();
};

export { FeatureFlagProvider } from './providers/FeatureFlagProvider';
export { useFeatureFlag } from './hooks/useFeatureFlag';
export type { FeatureFlag, FeatureFlagState } from './types';
